export const LANG_LT = `lt`;
export const LANG_EN = `en`;
export const LANG_UK = `uk`;

export const POSSIBLE_SEARCH_LANGS = [LANG_LT, LANG_EN, LANG_UK];

export const TRANSLATIONS = {
  hit: {
    _template: {
      [LANG_LT]: ``,
      [LANG_EN]: ``,
      [LANG_UK]: ``,
    },
    address: {
      [LANG_LT]: `Adresas`,
      [LANG_EN]: `Address`,
      [LANG_UK]: `Адреса`,
    },
    contacts: {
      [LANG_LT]: `Kontaktai`,
      [LANG_EN]: `Contacts`,
      [LANG_UK]: `Контакти`,
    },
    purpose: {
      [LANG_LT]: `Aprašymas`,
      [LANG_EN]: `Description`,
      [LANG_UK]: `Додаткова інформація`,
    },
    region: {
      [LANG_LT]: `Vieta`,
      [LANG_EN]: `Location`,
      [LANG_UK]: `Місцезнаходження`,
    },
    workingHours: {
      [LANG_LT]: `Darbo laikas`,
      [LANG_EN]: `Working hours`,
      [LANG_UK]: `Час роботи`,
    },
  },
  hitsPerPage: {
    [LANG_LT]: `puslapyje`,
    [LANG_EN]: `on the page`,
    [LANG_UK]: `у сторінці`,
  },
  langSwitcher: {
    language: {
      [LANG_LT]: `Kalba`,
      [LANG_EN]: `Language`,
      [LANG_UK]: `Мова`,
    },
  },
  refinements: {
    clearFilters: {
      [LANG_LT]: `Išvalyti filtrus`,
      [LANG_EN]: `Clear filters`,
      [LANG_UK]: `Очистіть фільтри`,
    },
    languages: {
      [LANG_LT]: `Kalba`,
      [LANG_EN]: `Service language`,
      [LANG_UK]: `Мова послуг`,
    },
    region: {
      [LANG_LT]: `Vieta`,
      [LANG_EN]: `Location`,
      [LANG_UK]: `Місцезнаходження`,
    },
    typeOfHelp: {
      [LANG_LT]: `Pagalbos rūšis`,
      [LANG_EN]: `Type of aid`,
      [LANG_UK]: `Вид допомоги`,
    },
    panelTitle: {
      [LANG_LT]: `Filtrai`,
      [LANG_EN]: `Filters`,
      [LANG_UK]: `Фільтри`,
    },
    doFilter: {
      [LANG_LT]: `Filtruoti`,
      [LANG_EN]: `Filter`,
      [LANG_UK]: `Фільтрувати`,
    },
  },
  searchBox: {
    [LANG_LT]: `Paieška`,
    [LANG_EN]: `Search`,
    [LANG_UK]: `Пошук`,
  },
  noResults: {
    [LANG_LT]: `Paieškai {query} rezultatų rasti nepavyko.`,
    [LANG_EN]: `No search results were found for {query}.`,
    [LANG_UK]: `Не знайдено результатів для {query}.`,
  },
};
